<div class="header-section">
  <div class="header-top">
    <div class="title-group">
      <h1 class="main-title">{{ title }}</h1>
      @if (activeTab === 'all') {
        <span class="quota-count">{{ quotaCount }}</span>
      }
    </div>
    <button class="info-icon" mat-icon-button (click)="openInfoModal()" [matTooltip]="'quota.supplierGuide' | translate">
      <mat-icon>info</mat-icon>
    </button>
  </div>
  <p class="subtitle">{{ subtitle }}</p>

  <div class="tabs">
    <button
      class="tab"
      [class.active]="activeTab === 'all'"
      (click)="navigateToTab('all')">
      {{ 'quota.allQuotas' | translate }}
    </button>
    <button
      class="tab"
      [class.active]="activeTab === 'my'"
      (click)="navigateToTab('my')">
      {{ 'quota.myQuotas' | translate }}
    </button>
    <button
      class="tab"
      [class.active]="activeTab === 'companies'"
      (click)="navigateToTab('companies')">
      Мои компании
    </button>
  </div>
</div>
